module.exports = __webpack_public_path__ + "omniv2/img/icon-phone.ce3beb33.svg";